import { FC, SVGProps } from "react";

const MinusThickIcon: FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg width="14" height="2" viewBox="0 0 14 2" fill="currentcolor" {...props}>
      <rect x="0.5" y="0.5" width="13" height="1" rx="0.5" fill="currentcolor" />
    </svg>
  );
};

export default MinusThickIcon;
